import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import dropOffLocationQueryKeys from "@modules/drop-off-location/dropOffLocationQueryKeys";
import tradeInQueryKeys from "@modules/trade/types/tradeInQueryKeys";

type Request = {
  source: string;
  tradeInToken: string;
};

const putCancelGuestBuyInAppointmentMutation = async ({
  source,
  tradeInToken,
}: Request) => {
  return api.rawPut(`api/purchases/ico/${source}/appointment/cancel`, {
    headers: {
      authorization: `Bearer ${tradeInToken}`,
    },
  });
};

export default function useCancelGuestBuyInAppointmentMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putCancelGuestBuyInAppointmentMutation,
    onSuccess: (_, { tradeInToken }) => {
      queryClient.invalidateQueries({
        queryKey: tradeInQueryKeys.appraisalByToken(tradeInToken),
      });
      queryClient.invalidateQueries({ queryKey: dropOffLocationQueryKeys.all });
    },
  });
}
